import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// ═══════════════════════════════════════════════
// Global Link Interceptor
// Forces ALL external links to open in a new tab.
// Catches edge cases: dangerouslySetInnerHTML content,
// markdown-rendered links, API-sourced HTML, etc.
// ═══════════════════════════════════════════════
document.addEventListener('click', e => {
  const anchor = (e.target as HTMLElement).closest('a');
  if (!anchor) return;
  const href = anchor.getAttribute('href');
  if (!href || href === '#' || href.startsWith('javascript:')) return;
  // Internal navigation (same origin, relative paths handled by app)
  const isInternal = href.startsWith('/') && !href.startsWith('//'); // relative path like /terms
  if (isInternal) return;
  // External link — force new tab
  if (!anchor.getAttribute('target')) {
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
  }
});
render(<App data-id="element-6796" />, document.getElementById('root'));